export const Routing = {
  LOGIN_PAGE: '/login',
  HOME_PAGE: '/',
};
